import commonFunc from "../common.func";
import constant from "../main.constants";
import router from "../router/index.js";

const toaster = {
    successHandler(messageSuccess, title, alreadyLocalized = false, ...args) {
        const id = `success-toast-${Date.now()}`;
        const localizedAlert =
            messageSuccess ?
                (alreadyLocalized ? messageSuccess : commonFunc.localizeAlert(messageSuccess, args)) :
                commonFunc.localize("success");

        const content = [this.$createElement(
            'span',
            localizedAlert
        ),
        this.$createElement('v-row', { class: "success-toaster-button-row" }, [
            this.$createElement(
                'v-icon', {
                on: { click: () => this.$bvToast.hide(id) },
                class: "toaster-close-button"
            },
                'mdi-close-circle',
            ),
        ])]
        this.$bvToast.toast(localizedAlert, {
            id: id,
            title: content,
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-top-right',
            autoHideDelay: constant.SUCCESS_COUNT_DOWN,
            noCloseButton: true
        });

    },

    errorHandler(messageError, alreadyLocalized = false, callback) {
        if (router.currentRoute.path == '/forbidden') { return; } //TODO: 403 sayfasına yönlendirilince uyarıların çıkmasını engellemek için geçici olarak koyuldu başka yöntem bulunmalı


        const elementButtonList = [
            this.$createElement(
                'v-icon', {
                on: { click: () => this.$bvToast.hide() },
                class: "close-all-errors-btn"
            },
                ['mdi-playlist-remove']

            ),
            this.$createElement(
                'v-icon', {
                on: { click: () => this.$bvToast.hide(id) },
                class: "toaster-close-button"
            },
                'mdi-close-circle',
            ),
        ];

        if (callback) {
            elementButtonList.unshift(this.$createElement(
                'v-icon', {
                on: { click: () => { this.$bvToast.hide(); callback() } },
                class: "close-all-errors-btn"
            },
                ['mdi-magnify']

            ))
        }


        const localizedAlert =
            messageError ?
                (alreadyLocalized ? messageError : commonFunc.localizeAlert(messageError)) :
                commonFunc.localizeAlert("Teknik bir hata oluştu!");
        const id = `error-toast-${Date.now()}`;
        const content = [
            this.$createElement(
                'span',
                localizedAlert
            ),
            this.$createElement('v-row', { class: "danger-toaster-button-row" }, elementButtonList)
        ]

        this.$bvToast.toast(content, {
            id: id,
            title: content,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-top-right',
            noAutoHide: true,
            noCloseButton: true
        });
    },

    warningHandler(messageWarning, title, alreadyLocalized = false) {
        const id = `warning-toast-${Date.now()}`;
        const localizedAlert =
            messageWarning ?
                (alreadyLocalized ? messageWarning : commonFunc.localizeAlert(messageWarning)) :
                commonFunc.localize("warning");
        const content = [this.$createElement(
            'span',
            localizedAlert
        ),
        this.$createElement('v-row', { class: "warning-toaster-button-row" }, [

            this.$createElement(
                'v-icon', {
                on: { click: () => this.$bvToast.hide(id) },
                class: "toaster-close-button"
            },
                'mdi-close-circle',
            ),
        ])]
        this.$bvToast.toast(content, {
            id: id,
            title: content,
            variant: 'warning',
            solid: true,
            toaster: 'b-toaster-top-right',
            autoHideDelay: constant.WARNING_COUNT_DOWN,
            noCloseButton: true
        });
    },

    cancelHandler(title) {
        const localizedAlert = commonFunc.localizeAlert("İşleminiz İptal Edilmiştir!");
        const content = [this.$createElement(
            'span',
            localizedAlert
        ),
        this.$createElement('v-row', { class: "warning-toaster-button-row" }, [

            this.$createElement(
                'v-icon', {
                on: { click: () => this.$bvToast.hide() },
                class: "toaster-close-button"
            },
                'mdi-close-circle',
            ),
        ])]
        this.$bvToast.toast(localizedAlert, {
            title: content,
            variant: 'warning',
            solid: true,
            toaster: 'b-toaster-top-right',
            autoHideDelay: constant.CANCEL_COUNT_DOWN,
            noCloseButton: true
        });
    }
}

export default toaster;
